"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.months = exports.rfc3999Regex = void 0;
exports.getDayAndMonth = getDayAndMonth;
exports.getFormattedDate = getFormattedDate;
exports.fromRFC3999stingToDate = fromRFC3999stingToDate;
exports.getDifference = getDifference;
exports.isBefore = isBefore;
exports.newDateAtMidnight = newDateAtMidnight;
exports.getUTCTime = getUTCTime;
exports.getTimeSince = getTimeSince;
exports.getPreviousSunday = getPreviousSunday;
exports.getWeekInYear = getWeekInYear;
exports.getWeekInMonth = getWeekInMonth;
exports.getDayInYear = getDayInYear;
exports.formatDate = formatDate;
exports.padWithZeroes = padWithZeroes;
exports.formatText = formatText;
exports.getTomorrowDate = getTomorrowDate;
var string_1 = require("./string");
exports.rfc3999Regex = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})\.?(\d+)?(.*)/;
exports.months = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
];
var regex = /('[^']*')|(G+|y+|M+|w+|W+|D+|d+|F+|f+|E+|a+|H+|k+|K+|h+|m+|s+|S+|Z+)|([a-zA-Z]+)|([^a-zA-Z']+)/;
var dayNames = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
];
function getDayAndMonth(date) {
    return date ? date.getDate() + " " + exports.months[date.getMonth()] : "";
}
function getFormattedDate(date) {
    return date
        ? date.getDate() + " " + exports.months[date.getMonth()] + " " + date.getFullYear()
        : "";
}
function fromRFC3999stingToDate(rfcString) {
    var m = exports.rfc3999Regex.exec(rfcString);
    if (!m)
        throw new Error("fromRFC3999stingToDate could not parse string as date: '".concat(rfcString, "'."));
    try {
        //milliseconds are optional.
        if (m[7] === undefined) {
            m[7] = "0";
        }
        var year = +m[1];
        var month = +m[2];
        var day = +m[3];
        var hour = +m[4];
        var minute = +m[5];
        var second = +m[6];
        // group number 7 - is a fraction of second, not millisecond
        var msec = +(0, string_1.padRight)(3, m[7].substring(0, 3), "0");
        var zone = m[8];
        if (zone === "Z") {
            return new Date(Date.UTC(year, month - 1, day, hour, minute, second, msec));
        }
        if (!zone) {
            return new Date(year, month - 1, day, hour, minute, second, msec);
        }
        var zoneRegExp = /^(\+\d{2}|-\d{2}):(\d{2})$/;
        var zomeMatch = zoneRegExp.exec(zone);
        if (!zomeMatch)
            throw new Error("could not parse zone");
        var tzHour = +zomeMatch[1];
        var tzMin = +zomeMatch[2];
        var tzOffset = tzHour * 60 + tzMin;
        return new Date(Date.UTC(year, month - 1, day, hour, minute - tzOffset, second, msec));
    }
    catch (e) {
        throw new Error("fromRFC3999stingToDate could not parse string as date: '".concat(rfcString, "'.") +
            e.message);
    }
}
function getDifference(date1, date2) {
    return date1.getTime() - date2.getTime();
}
function isBefore(date, newDate) {
    return date.getTime() < newDate.getTime();
}
var TEXT2 = 0, TEXT3 = 1, NUMBER = 2, YEAR = 3, MONTH = 4, TIMEZONE = 5;
var types = {
    G: TEXT2,
    y: YEAR,
    M: MONTH,
    w: NUMBER,
    W: NUMBER,
    D: NUMBER,
    d: NUMBER,
    F: NUMBER,
    f: NUMBER,
    E: TEXT3,
    a: TEXT2,
    H: NUMBER,
    k: NUMBER,
    K: NUMBER,
    h: NUMBER,
    m: NUMBER,
    s: NUMBER,
    S: NUMBER,
    Z: TIMEZONE,
};
var ONE_DAY = 24 * 60 * 60 * 1000;
var ONE_WEEK = 7 * ONE_DAY;
var DEFAULT_MINIMAL_DAYS_IN_FIRST_WEEK = 1;
function newDateAtMidnight(year, month, day) {
    var d = new Date(year, month, day, 0, 0, 0);
    d.setMilliseconds(0);
    return d;
}
function getUTCTime(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function getTimeSince(endDate, beginDate) {
    return getUTCTime(beginDate) - getUTCTime(endDate);
}
function getPreviousSunday(date) {
    // Using midday avoids any possibility of DST messing things up
    var midday = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
    var previousSunday = new Date(midday.getTime() - date.getDay() * ONE_DAY);
    return newDateAtMidnight(previousSunday.getFullYear(), previousSunday.getMonth(), previousSunday.getDate());
}
function getWeekInYear(date, minimalDaysInFirstWeek) {
    if (isUndefined(date["minimalDaysInFirstWeek"])) {
        minimalDaysInFirstWeek = DEFAULT_MINIMAL_DAYS_IN_FIRST_WEEK;
    }
    var previousSunday = getPreviousSunday(date);
    var startOfYear = newDateAtMidnight(date.getFullYear(), 0, 1);
    var numberOfSundays = isBefore(previousSunday, startOfYear)
        ? 0
        : 1 + Math.floor(getTimeSince(previousSunday, startOfYear) / ONE_WEEK);
    var numberOfDaysInFirstWeek = 7 - startOfYear.getDay();
    var weekInYear = numberOfSundays;
    if (numberOfDaysInFirstWeek < minimalDaysInFirstWeek) {
        weekInYear--;
    }
    return weekInYear;
}
function getWeekInMonth(date, minimalDaysInFirstWeek) {
    var previousSunday = getPreviousSunday(date);
    var startOfMonth = newDateAtMidnight(date.getFullYear(), date.getMonth(), 1);
    var numberOfSundays = isBefore(previousSunday, startOfMonth)
        ? 0
        : 1 + Math.floor(getTimeSince(previousSunday, startOfMonth) / ONE_WEEK);
    var numberOfDaysInFirstWeek = 7 - startOfMonth.getDay();
    var weekInMonth = numberOfSundays;
    if (numberOfDaysInFirstWeek >= minimalDaysInFirstWeek) {
        weekInMonth++;
    }
    return weekInMonth;
}
function getDayInYear(date) {
    var startOfYear = newDateAtMidnight(date.getFullYear(), 0, 1);
    return 1 + Math.floor(getTimeSince(date, startOfYear) / ONE_DAY);
}
function isUndefined(obj) {
    return typeof obj == "undefined";
}
function formatDate(date, formatString) {
    var formattedString = "";
    var result;
    var searchString = formatString;
    while ((result = regex.exec(searchString))) {
        var quotedString = result[1];
        var patternLetters = result[2];
        var otherLetters = result[3];
        var otherCharacters = result[4];
        // If the pattern matched is quoted string, output the text between the quotes
        if (quotedString) {
            if (quotedString == "''") {
                formattedString += "'";
            }
            else {
                formattedString += quotedString.substring(1, quotedString.length - 1);
            }
        }
        else if (otherLetters) {
            // Swallow non-pattern letters by doing nothing here
        }
        else if (otherCharacters) {
            // Simply output other characters
            formattedString += otherCharacters;
        }
        else if (patternLetters) {
            // Replace pattern letters
            var patternLetter = patternLetters.charAt(0);
            var numberOfLetters = patternLetters.length;
            var rawData = "";
            switch (patternLetter) {
                case "G":
                    rawData = "AD";
                    break;
                case "y":
                    rawData = date.getFullYear();
                    break;
                case "M":
                    rawData = date.getMonth();
                    break;
                case "w":
                    rawData = getWeekInYear(date, 1);
                    break;
                case "W":
                    rawData = getWeekInMonth(date, 1);
                    break;
                case "D":
                    rawData = getDayInYear(date);
                    break;
                case "d":
                    rawData = date.getDate();
                    break;
                case "F":
                    rawData = 1 + Math.floor((date.getDate() - 1) / 7);
                    break;
                case "E":
                    rawData = dayNames[date.getDay()];
                    break;
                case "a":
                    rawData = date.getHours() >= 12 ? "PM" : "AM";
                    break;
                case "H":
                    rawData = date.getHours();
                    break;
                case "k":
                    rawData = date.getHours() || 24;
                    break;
                case "K":
                    rawData = date.getHours() % 12;
                    break;
                case "h":
                    rawData = date.getHours() % 12 || 12;
                    break;
                case "m":
                    rawData = date.getMinutes();
                    break;
                case "s":
                    rawData = date.getSeconds();
                    break;
                case "f":
                    rawData = date.getMilliseconds();
                    break;
                case "Z":
                    rawData = date.getTimezoneOffset(); // This returns the number of minutes since GMT was this time.
                    break;
            }
            // Format the raw data depending on the type
            switch (types[patternLetter]) {
                case TEXT2:
                    formattedString += formatText(rawData, numberOfLetters, 2);
                    break;
                case TEXT3:
                    formattedString += formatText(rawData, numberOfLetters, 3);
                    break;
                case NUMBER:
                    formattedString += formatNumber(rawData, numberOfLetters);
                    break;
                case YEAR:
                    if (numberOfLetters <= 3) {
                        // Output a 2-digit year
                        var dataString = "" + rawData;
                        formattedString += dataString.substr(2, 2);
                    }
                    else {
                        formattedString += formatNumber(rawData, numberOfLetters);
                    }
                    break;
                case MONTH:
                    if (numberOfLetters >= 3) {
                        formattedString += formatText(exports.months[rawData], numberOfLetters, numberOfLetters);
                    }
                    else {
                        // NB. Months returned by getMonth are zero-based
                        formattedString += formatNumber(rawData + 1, numberOfLetters);
                    }
                    break;
                case TIMEZONE:
                    var isPositive = false;
                    if (typeof rawData === "number") {
                        isPositive = rawData > 0;
                    }
                    // The following line looks like a mistake but isn't
                    // because of the way getTimezoneOffset measures.
                    var prefix = isPositive ? "-" : "+";
                    var absData = Math.abs(rawData);
                    // Hours
                    var hours = "" + Math.floor(absData / 60);
                    hours = padWithZeroes(hours, 2);
                    // Minutes
                    var minutes = "" + (absData % 60);
                    minutes = padWithZeroes(minutes, 2);
                    formattedString += prefix + hours + minutes;
                    break;
            }
        }
        searchString = searchString.substr(result.index + result[0].length);
    }
    return formattedString;
}
function padWithZeroes(str, len) {
    while (str.length < len) {
        str = "0" + str;
    }
    return str;
}
function formatText(data, numberOfLetters, minLength) {
    return numberOfLetters >= 4
        ? data
        : data.substr(0, Math.max(minLength, numberOfLetters));
}
function formatNumber(data, numberOfLetters) {
    var dataString = "" + data;
    // Pad with 0s as necessary
    return padWithZeroes(dataString, numberOfLetters);
}
function getTomorrowDate(now) {
    var date = new Date(now);
    date.setDate(date.getDate() + 1);
    return date;
}
